import { API_BASE_URL } from "./constants";
import type { VideoInterface } from "../types/video.interface";
import { authenticatedFetch } from "@beholos/holoscommon";

export interface VideoReviews {
  rating: number;
  user: {
    firstname: string;
  };
  review: string;
  date: string;
}

export interface FetchVideoDetailsBySlugResponse {
  video: VideoInterface;
  review?: VideoReviews;
  reviews: VideoReviews[];
  isFavorite: boolean;
}

export interface VideoFilter {
  name: string;
  _id: string;
}

export interface CategorizedVideos {
  _id: {
    _id: string;
    name: string;
  };
  videos: VideoInterface[];
};


export interface FetchVideosResponse {
  data: VideoInterface[] | CategorizedVideos[];
  totalResults: number;
  totalPages: number;
  availableFilters: {
    categories: VideoFilter[];
    studios: VideoFilter[];
    equipment: VideoFilter[];
    genericCategories: VideoFilter[];
    saasCategories: VideoFilter[];
    teachers: string[];
  }[];
}

export const fetchVideos = async (filters: {
  search: string;
  category: string;
  saasCategory: string;
  teacher: string;
  partner: string;
  duration: string;
  equipment: string;
}, page: number = 1): Promise<FetchVideosResponse> => {
  try {
    const queryParams = new URLSearchParams({
      title: filters.search,
      category: filters.category,
      saasCategory: filters.saasCategory,
      teacher: filters.teacher,
      studio: filters.partner,
      duration: filters.duration,
      equipment: filters.equipment,
      page: String(page),
    });

    const response = await authenticatedFetch(`${API_BASE_URL}/videos?${queryParams}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: FetchVideosResponse = await response.json();
    console.log('Videos API response:', data);

    return data;
  } catch (error) {
    console.error('Error fetching videos:', error);
    return {
      data: [],
      totalResults: 0,
      totalPages: 0,
      availableFilters: [{
        categories: [],
        studios: [],
        equipment: [],
        genericCategories: [],
        saasCategories: [],
        teachers: []
      }],
    };
  }
}

export const fetchVideoDetails = async (slug: string): Promise<FetchVideoDetailsBySlugResponse> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/videos/details/${slug}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: FetchVideoDetailsBySlugResponse = await response.json();
    console.log('Video API response:', data);

    return data;
  } catch (error) {
    console.error('Error fetching video details:', error);
    return {
      video: {} as VideoInterface,
      reviews: [],
      isFavorite: false,
    };
  }
};

export const completedVideo = async (id: string): Promise<void> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/videos/completed`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

  } catch (error) {
    console.error('Error completing video:', error);
  }
};

export const createReview = async ({
  id,
  rating,
  review,
}: { id: string, rating: number, review: string }): Promise<void> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/videos/review`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        video: id,
        rating,
        review
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error completing video:', error);
  }
};